/**
 * The root of every query holding the caller's survey responses.
 *
 * A survey submit invalidates this root by prefix, and the poll history nests
 * under it, so one definition here is what keeps the history refreshing after
 * an answer. Change it only as a deliberate cache migration.
 */
export const mySurveyResponsesKey = (userId: string | undefined) =>
  ['mySurveyResponsesV2', userId] as const;
